import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import { Button } from '@material-ui/core'

const buttonStyle = {
  borderRadius: 4,
  padding: '0 1rem',
  height: '47px',
  fontSize: '.875rem',
  letterSpacing: '1.5px',
  textTransform: 'uppercase',
  whiteSpace: 'nowrap'
}

const styles = (theme) => ({
  white: {
    ...buttonStyle,
    color: theme.colors.blue5,
    backgroundColor: theme.colors.white,
    '&:hover': {
      color: theme.colors.blue5,
      backgroundColor: theme.colors.grey2,
      boxShadow: theme.shadows[2]
    }
  },
  grey: {
    ...buttonStyle,
    color: theme.colors.white,
    backgroundColor: theme.colors.grey5,
    '&:hover': {
      color: theme.colors.white,
      backgroundColor: theme.colors.grey5,
      boxShadow: theme.shadows[2]
    }
  },
  greyoutlined: {
    ...buttonStyle,
    backgroundColor: 'transparent',
    border: '2px solid ' + theme.colors.grey2,
    color: 'currentColor',
    position: 'relative',
    '&::after': {
      top: 0,
      left: '-1%',
      width: '102%',
      height: '101%',
      content: '""',
      opacity: 0.5,
      position: 'absolute',
      backgroundColor: 'transparent',
      transition: 'backgroundColor 0.3s'
    },
    '&:hover': {
      color: 'currentColor',
      backgroundColor: 'rgba(255, 255, 255, .3)',
      '&::after': {
        backgroundColor: theme.colors.grey2
      }
    }
  },
  blue5outlined: {
    ...buttonStyle,
    backgroundColor: 'transparent',
    border: '2px solid' + theme.colors.blue5,
    '&:hover': {
      color: theme.colors.blue5,
      border: '2px solid ' + theme.colors.blue5,
      backgroundColor: 'rgba(255, 255, 255, .3)',
      '&::after': {
        backgroundColor: theme.colors.grey2
      }
    }
  },
  pink: {
    ...buttonStyle,
    color: theme.colors.white,
    backgroundColor: theme.colors.pink,
    '&:hover': {
      color: theme.colors.white,
      backgroundColor: theme.colors.pink,
      backgroundImage: 'linear-gradient(105deg, rgb(255, 101, 132), rgb(255, 76, 112))',
      boxShadow: '2px 2px 10px 0 rgba(255, 101, 132, 0.3), 0 1px 3px 0 rgba(255, 101, 132, 0.3)'
    }
  },
  red: {
    ...buttonStyle,
    color: theme.colors.white,
    backgroundColor: theme.colors.error,
    '&:hover': {
      color: theme.colors.white,
      backgroundColor: theme.colors.error,
      boxShadow: theme.shadows[2]
    }
  },
  whiteOutlined: {
    ...buttonStyle,
    color: theme.colors.white,
    backgroundColor: 'transparent',
    borderColor: theme.colors.white,
    '&:hover': {
      color: theme.colors.white,
      backgroundColor: 'transparent',
      '&::after': {
        content: '""',
        position: 'absolute',
        width: '100%',
        height: '100%',
        left: 0,
        top: 0,
        backgroundColor: theme.colors.white,
        opacity: 0.5
      }
    }
  },
  whiteSmall: {
    ...buttonStyle,
    padding: '0 1rem',
    height: '40px',
    color: theme.colors.blue5,
    backgroundColor: theme.colors.white,
    '&:hover': {
      color: theme.colors.blue5,
      backgroundColor: theme.colors.white,
      boxShadow: theme.shadows[2]
    }
  },
  text: {
    ...buttonStyle,
    padding: '0 1rem',
    color: 'currentColor',
    backgroundColor: 'transparent',
    '&:hover': {
      color: 'currentColor',
      '&::after': {
        content: '""',
        position: 'absolute',
        width: '100%',
        height: '100%',
        left: 0,
        top: 0,
        borderRadius: 4,
        backgroundColor: theme.colors.blue5,
        opacity: 0.1
      }
    }
  },
  blue1: {
    ...buttonStyle,
    color: theme.colors.white,
    backgroundImage: 'linear-gradient(105deg, #299dc1, #299dc1)',
    '&:hover': {
      color: theme.colors.white,
      backgroundImage: 'linear-gradient(105deg, #16bce6, #299dc1)',
      boxShadow: '2px 2px 10px 0 rgba(41, 157, 193, 0.3), 0 1px 3px 0 rgba(41, 157, 193, 0.3)'
    },
    '&:focus': {
      color: theme.colors.white
    }
  },
  blue1outlined: {
    ...buttonStyle,
    backgroundColor: 'transparent',
    border: '2px solid' + theme.colors.blue1,
    color: theme.colors.blue1,
    '&:hover': {
      color: theme.colors.blue1,
      border: '2px solid ' + theme.colors.blue1
    }
  },
  blue5: {
    ...buttonStyle,
    color: theme.colors.white,
    backgroundImage: `linear-gradient(100deg, ${theme.colors.blue5}, ${theme.colors.blue5})`,
    '&:hover': {
      color: theme.colors.white,
      backgroundImage: `linear-gradient(100deg, ${theme.colors.blue4}, ${theme.colors.blue5})`
    }
  }
})

function CustomButton(props) {
  const { children, classes, color, ...other } = props
  const customTypoProps = classes[color] ? { className: classes[color] } : { color }

  return (
    <Button {...other} {...customTypoProps}>
      {children || 'class names'}
    </Button>
  )
}

export default withStyles(styles)(CustomButton)
